'use client'

import { ChevronDownIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import { useId, useState } from 'react'
import { FullBleedBand } from '@/General/FullBleedBand'
import { FREE_MAGIC_FAQ_ITEMS } from './faqData'

const ACCENT_BG = 'bg-[#f2f2f2]'

export function FreeMagicDownloadsFaqAccordion() {
  const baseId = useId()
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <FullBleedBand className={clsx('mt-10 py-4 md:py-8', ACCENT_BG)}>
      <section aria-labelledby={`${baseId}-faq-heading`}>
        <h2
          id={`${baseId}-faq-heading`}
          className="mb-4 text-xl font-bold md:text-3xl"
        >
          Free magic downloads: questions and answers
        </h2>
        <div className="border-t border-gray-300/80">
          {FREE_MAGIC_FAQ_ITEMS.map((item, index) => {
            const triggerId = `${baseId}-faq-trigger-${index}`
            const panelId = `${baseId}-faq-panel-${index}`
            const isOpen = openIndex === index

            return (
              <div key={item.question} className="border-b border-gray-300/80">
                <h3 className="m-0 text-xl font-bold">
                  <button
                    id={triggerId}
                    type="button"
                    onClick={() =>
                      setOpenIndex(prev => (prev === index ? null : index))
                    }
                    className={clsx(
                      'flex w-full cursor-pointer items-center justify-between gap-3 py-4 text-left text-xl font-bold text-black',
                      'focus:outline-none focus-visible:ring-2 focus-visible:ring-vi-red focus-visible:ring-offset-2',
                      ACCENT_BG
                    )}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                  >
                    <span className="pr-2">{item.question}</span>
                    <ChevronDownIcon
                      className={clsx(
                        'h-6 w-6 shrink-0 transition-transform duration-200',
                        isOpen && 'rotate-180'
                      )}
                      aria-hidden
                    />
                  </button>
                </h3>
                {isOpen && (
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={triggerId}
                    className="border-t border-gray-300/80 bg-white/60 pb-4 pt-3 text-xl text-gray-900"
                  >
                    <div
                      className="max-w-none"
                      dangerouslySetInnerHTML={{ __html: item.answerHtml }}
                    />
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </section>
    </FullBleedBand>
  )
}
